/* SetDefaultConfigAction.js */

"use strict";

const DEVICE_NAME_MAX_LENGTH = 60;
const DEVICE_NAME_LIST_LENGTH = 10;

class SetDefaultConfigAction {
    constructor(logger, gameEditor, activeView, userSession, DeviceEntity, userFeedback) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._DeviceEntity = DeviceEntity;
        this._selectedDeviceIds = [];
        this._selectedDeviceNames = [];
        this._modalUserFeedback = userFeedback;

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }
    run() {
        if (this._selectedDeviceIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getDeviceEntitiesNameById(this._selectedDeviceIds);
                    }
                    return Promise.resolve();
                })
                .then((selectedDeviceNames) => {
                    this._selectedDeviceNames = selectedDeviceNames;
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        if (Array.isArray(this._selectedDeviceNames) && this._selectedDeviceNames.length > 0) {
                            let s = this._selectedDeviceNames.length > 1 ? "s" : "";
                            this._message =
                                "Are you sure you want to set the latest captured configuration as the default configuration for the selected device" +
                                s +
                                "?\n";
                            Object.keys(this._selectedDeviceNames).forEach((id) => {
                                let deviceName = this._selectedDeviceNames[id];
                                let shortDeviceName =
                                    deviceName.length > DEVICE_NAME_MAX_LENGTH ? deviceName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…" : deviceName;
                                this._message += "\n" + shortDeviceName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected devices"));
                        }
                    } else {
                        this._message = `Are you sure you want to set the latest captured configuration as the default configuration for the selected ${this._selectedDeviceIds.length} devices?\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    const showProgFunc = (prog) => {
                        this._modalUserFeedback.showLoadingProgress(`${prog.successCount} of ${prog.targetCount}`);
                    };
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Set Default Configuration",
                            confirmDetails: {
                                text: "Confirm",
                                type: "additive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            let workInputs = {};
                            let workTarget = {
                                method: "multi",
                                ids: this._selectedDeviceIds
                            };
                            return this._DeviceEntity.runSetLatestConfigAsStableWork(
                                this._activeOrgId,
                                workTarget,
                                workInputs,
                                { launchAndForget: true },
                                showProgFunc
                            );
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "SetDefaultConfigAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = SetDefaultConfigAction;

SetDefaultConfigAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.Device",
    "$teve.ui.userFeedback"
];

SetDefaultConfigAction.$displayDetails = {
    type: "Action",
    name: "SetDefaultConfigAction",
    icon: "common.star",
    shown: true,
    title: "Set Default Configuration",
    order: 8
};
